import { Link } from 'react-router-dom';
import { Sparkles, ArrowLeft } from 'lucide-react';
import { Logo } from '../components/Logo';

export function ComingSoonPage() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-4 py-12 text-center animate-fade-in">
      <div className="mb-6 flex justify-center">
        <Logo height={40} />
      </div>

      <div className="relative mb-6">
        <div className="absolute inset-0 scale-150 rounded-full bg-ol-orange/10 blur-xl" />
        <div className="relative flex h-20 w-20 items-center justify-center rounded-2xl border border-ol-orange/20 bg-white shadow-xl">
          <Sparkles className="h-10 w-10 text-ol-orange animate-pulse" />
        </div>
      </div>

      <h1 className="text-2xl font-bold tracking-tight text-ol-process-blue md:text-3xl">
        Feature Launch Pending
      </h1>

      <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-steel">
        This workspace is currently undergoing internal deployment or is temporarily deactivated for your region. Check back soon for the official launch!
      </p>

      <div className="mt-8">
        <Link
          to="/"
          className="inline-flex items-center gap-2 rounded-xl bg-ol-orange px-5 py-3 text-sm font-bold text-white shadow-md hover:bg-ol-orange-600 transition-all focus:outline-none focus:ring-2 focus:ring-ol-orange focus:ring-offset-2 hover:-translate-y-0.5"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
}
